var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrawtoolsRectangle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ikonit"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20,3a3,3,0,0,0-5.82-1H4A2,2,0,0,0,2,4V9.18A3,3,0,1,0,5.82,13H16a2,2,0,0,0,2-2V5.82A3,3,0,0,0,20,3ZM3,13a1,1,0,1,1,1-1A1,1,0,0,1,3,13Zm2.82-2A3,3,0,0,0,4,9.18V4H14.18A3,3,0,0,0,16,5.82V11ZM17,4a1,1,0,1,1,1-1A1,1,0,0,1,17,4Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawtoolsRectangle);
export default __webpack_public_path__ + "static/media/drawtools_rectangle.120c02e48ad6a72285f8007fb11674c2.svg";
export { ForwardRef as ReactComponent };